import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list-loading h-100"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_4 = { class: "w-50" }
const _hoisted_5 = { class: "d-flex align-end w-25" }
const _hoisted_6 = { class: "mx-auto my-2 w-100" }
const _hoisted_7 = { class: "d-flex w-100 justify-content-end mb-4 pr-6" }

import { ref, Ref, watch } from "vue";
import selectBox from "@/components/Common/selectBox.vue"
import BaseAutoCompleteWithSingleSelectedItem from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue";
import AllowAccessOfficesEditList from "@/components/AllowAccessOfficeParts/AllowAccessOfficesEditList.vue"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getAllowAccessOfficeResponse from "@/types/responses/getAllowAccessOffice"
import { useAuth } from "@/services/user/Auth0UserProvider"
import Api from "@/services/api/ApiServiceFabrick"
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import { SELECTABLE_STATUSES } from "@/services/consts/allow_access_office";
import i18n from '@/lang/i18n';

type keyValue = {
  key: string | number,
  value: string | number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AllowAccessOfficeModal',
  props: {
    selectedAccount: {},
    operationOffices: {},
    modalState: { type: Boolean },
    showFlash: { type: Function }
  },
  emits: ['closeModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const title = i18n.global.t('pages.allowAccessOffice.title.edit')

const state: Ref<boolean> = ref(false)
const operationOffice: Ref<getOperationOffice | undefined> = ref()
const closeBtnName = i18n.global.t('pages.common.button.close')
const isLoading: Ref<boolean> = ref(false)
const AllowAccessOffices: Ref<getAllowAccessOfficeResponse[]> = ref([])
const filterAllowAccessOffices: Ref<getAllowAccessOfficeResponse[]> = ref([])
const createAuthority = ref(false)
const deleteAuthority = ref(false)
const selectedStatusKey: Ref<keyValue> = ref(SELECTABLE_STATUSES[0])
const { loginWithRedirect } = useAuth()

function getData() {
  getAllowAccessOffices()
  getAuthorityList()
}

function getAllowAccessOffices() {
  isLoading.value = true
  Api().getAllowAccessOffices().then((data: getAllowAccessOfficeResponse[]) => {
    AllowAccessOffices.value = data
    filterAllowAccessOffices.value = filterByAccountAllowAccessOffice(data)
    isLoading.value = false
  }).catch((error) => {
    return errorHandle(error.response)
  })
}

const getAuthorityList = async(isError = false) => {
  if (isError) await AuthorityCacheApi.reflesh()
  const authorityList = await AuthorityCacheApi.getWithParse()
  createAuthority.value = authorityList["octlink.allow_access_office.update"]
  deleteAuthority.value = authorityList["octlink.allow_access_office.update"]
}

function filterByAccountAllowAccessOffice(allowAccessOffices: getAllowAccessOfficeResponse[]) {
  return allowAccessOffices.filter((allowAccessOffice) => {
    return allowAccessOffice.account_id == props.selectedAccount.id
  })
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      state.value = false
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      state.value = false
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", false)
      break
  }
  return state.value = false
}

function close() {
  operationOffice.value = undefined
  emits('closeModal', false)
}

function inactiveModal(isSucceeded: boolean) {
  if (!isSucceeded) return getAuthorityList(true)
  getAllowAccessOffices()
}

watch(() => props.modalState, (value: boolean) => {
  state.value = value
  if (state.value) {
    if (AllowAccessOffices.value.length) return filterAllowAccessOffices.value = filterByAccountAllowAccessOffice(AllowAccessOffices.value)
    getData()
  }
  selectedStatusKey.value = SELECTABLE_STATUSES[0]
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    id: "modal",
    modelValue: state.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state).value = $event)),
    width: "50%",
    class: "allow-access-office-modal",
    persistent: ""
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, {
        style: {"background-color":"white"},
        class: "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "fs-6 fw-bold grey lighten-2 mx-auto mt-1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(`${_unref(i18n).global.t('pages.allowAccessOffice.accountName')}: ${props.selectedAccount.last_name + props.selectedAccount.first_name}`) + " ", 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(BaseAutoCompleteWithSingleSelectedItem, {
                      items: props.operationOffices,
                      modelValue: operationOffice.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operationOffice).value = $event)),
                      label: _unref(i18n).global.t('pages.allowAccessOffice.operationOffice'),
                      itemName: "name"
                    }, null, 8, ["items", "modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(selectBox, {
                      modelValue: selectedStatusKey.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedStatusKey).value = $event)),
                      items: _unref(SELECTABLE_STATUSES),
                      clearable: false
                    }, null, 8, ["modelValue", "items"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(AllowAccessOfficesEditList, {
                  allowAccessOffices: filterAllowAccessOffices.value,
                  account: props.selectedAccount,
                  operationOffices: operationOffice.value ? [operationOffice.value] : props.operationOffices,
                  createAuthority: createAuthority.value,
                  deleteAuthority: deleteAuthority.value,
                  selectedStatusKey: selectedStatusKey.value,
                  onInactiveModal: inactiveModal
                }, null, 8, ["allowAccessOffices", "account", "operationOffices", "createAuthority", "deleteAuthority", "selectedStatusKey"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_btn, {
              class: "close-btn",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(closeBtnName)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})